module.exports = __webpack_public_path__ + "static/images/pop-add.4252d8d.png";